const truthy = (value) => ['1', 'true', 'yes', 'on'].includes(String(value || '').trim().toLowerCase());

export const ATLAS_PLAYWRIGHT_AUTH_DISABLED =
  process.env.NODE_ENV !== 'production' && truthy(process.env.REACT_APP_ATLAS_PLAYWRIGHT_AUTH_DISABLED);

const actorUserId = Number(process.env.REACT_APP_ATLAS_PLAYWRIGHT_ACTOR_USER_ID || 0);
const targetUserId = Number(process.env.REACT_APP_ATLAS_PLAYWRIGHT_USER_ID || 1);
const isAdmin = process.env.REACT_APP_ATLAS_PLAYWRIGHT_IS_ADMIN == null
  ? true
  : truthy(process.env.REACT_APP_ATLAS_PLAYWRIGHT_IS_ADMIN);

export function getPlaywrightIdToken() {
  return process.env.REACT_APP_ATLAS_PLAYWRIGHT_AUTH_TOKEN || 'playwright-disabled-auth';
}

export function getPlaywrightUser() {
  return {
    id: Number.isFinite(actorUserId) ? actorUserId : 0,
    email: process.env.REACT_APP_ATLAS_PLAYWRIGHT_ACTOR_EMAIL || 'playwright-admin@realtorch.local',
    name: process.env.REACT_APP_ATLAS_PLAYWRIGHT_ACTOR_NAME || 'Playwright Atlas Admin',
    isAdmin,
  };
}

export function getPlaywrightTargetUserId() {
  return Number.isFinite(targetUserId) ? targetUserId : 1;
}

export function getPlaywrightClients() {
  if (!isAdmin) {
    return [];
  }
  const clientId = getPlaywrightTargetUserId();
  return [
    {
      id: clientId,
      email: process.env.REACT_APP_ATLAS_PLAYWRIGHT_USER_EMAIL || `playwright-user-${clientId}@realtorch.local`,
      name: process.env.REACT_APP_ATLAS_PLAYWRIGHT_USER_NAME || `Playwright User ${clientId}`,
      is_admin: false,
      company_memberships: [],
    },
  ];
}

export function getPlaywrightSelectedClient() {
  return isAdmin ? String(getPlaywrightTargetUserId()) : null;
}

export function getPlaywrightCoverageState() {
  const dataUserId = isAdmin ? getPlaywrightTargetUserId() : getPlaywrightUser().id;
  return {
    data_user_id: dataUserId,
    user: {
      id: dataUserId,
      email: process.env.REACT_APP_ATLAS_PLAYWRIGHT_USER_EMAIL || `playwright-user-${dataUserId}@realtorch.local`,
      name: process.env.REACT_APP_ATLAS_PLAYWRIGHT_USER_NAME || `Playwright User ${dataUserId}`,
    },
    accessible_zip_codes: [],
    company_zip_codes: [],
    company_zip_coverage: [],
    company_zip_codes_by_status: {
      active: [],
      demo: [],
      inactive: [],
    },
    zip_contexts: [],
    company_zip_contexts: [],
    company_memberships: [],
    has_company_membership: false,
    default_zip: null,
  };
}
